import { SearchProducts } from '../../models';

export const searchConfigByProduct = {
    [SearchProducts.DYNPACK]: {
        path: '/travel/dp',
        fragment: 'dpresults_accommodation',
    },

    [SearchProducts.DYNPACK_OF2]: {
        path: '/travel/dynpack',
        fragment: 'dpresults_accommodation',
        search: '?flowProduct=dp&redirectAb=of2',
    },

    [SearchProducts.FLIGHTS]: {
        path: '/travel',
        fragment: 'results',
        queryParam: 'flightsDeeplink'
    },

    [SearchProducts.TRAINS]: {
        path: '/travel/trains',
        fragment: 'results',
        queryParam: 'flightsDeeplink'
    },

    [SearchProducts.INSPIRATIONAL]: {
        path: '/frontend-home',
        fragment: 'inspirational'
    },

    [SearchProducts.HOTEL_STANDALONE]: {
        path: '/travel/accommodation',
        fragment: 'hotel_results'
    },

    [SearchProducts.HOTELS_HOME]: {
        path: '/frontend-home/hotels',
        fragment: ''
    }
};
